import { Patterns } from './patterns/Patterns';
import { getBarChartProps } from './helpers/getBarChartProps';
import { Axis } from '../Axis';
import { formatNumber } from '@dop/shared/helpers/string';
import { Legend } from './Legend';
import { Bars } from './Bars';
import { useBarGraphMeasurements } from './helpers/useBarGraphMeasurements';
import { Label } from '../Label';
import { colors } from '@/uiPrimitives/color/colors.css';
import { ChartContainer } from '../ChartContainer';
import {
	axisFontStyle,
	fontStyle,
	yAxisLabelBlockSize,
} from '../cbsGraph.config';

export const BarChart = (
	barGraphProps: ReturnType<typeof getBarChartProps>,
) => {
	const {
		valuesByComparingDimension,
		title,
		description,
		axis,
		legend,
		globalMin,
		globalMax,
		unit,
		decimals,
		tickCount,
		tickValues,
	} = barGraphProps;
	const {
		xDomainPadding,
		padding,
		barOffset,
		barInlineSize,
		yAxisTickLabelInlineSize,
	} = useBarGraphMeasurements(barGraphProps);

	return (
		<ChartContainer
			title={title}
			description={description}
			globalMin={globalMin}
			globalMax={globalMax}
			padding={padding}
			domainPadding={{ x: xDomainPadding }}
		>
			<Patterns />
			{Axis({
				labelText: axis.yAxisDimensionInfo.title,
				tickLabelComponent: Label({
					style: { ...fontStyle, fontSize: 14 },
					lineHeight: 0.8,
					x: yAxisTickLabelInlineSize + yAxisLabelBlockSize,
					textAnchor: 'end',
				}),
				axisLabelComponent: Label({
					style: {
						...axisFontStyle,
						fontWeight: 'bold',
					},
					verticalAnchor: 'end',
					x: 15,
				}),
				style: {
					axis: {
						stroke: colors.shape.positive.muted,
						strokeWidth: 1,
					},
				},
			})}
			{Axis({
				dependentAxis: true,
				labelText: unit,
				fixLabelOverlap: true,
				tickCount: Math.min(tickCount, 3),
				tickValues,
				tickFormat: (number: number) => formatNumber({ number, decimals }),
				tickLabelSpace: 10,
			})}
			{Bars({
				valuesByComparingDimension,
				decimals,
				unit,
				barOffset,
				barInlineSize,
			})}
			{Legend({
				valuesByComparingDimension,
				legend,
			})}
		</ChartContainer>
	);
};
